import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container container-default"
}
const _hoisted_2 = { class: "step step-default" }
const _hoisted_3 = {
  key: 1,
  class: "container container-default"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "step step-default" }, "已开始下载游戏…", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "step step-prompt" }, [
  /*#__PURE__*/_createTextVNode(" 若提示下载应用市场版本，请选择"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "step-red" }, "“源文件”"),
  /*#__PURE__*/_createTextVNode("进行下载 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.url)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.errMsg), 1)
      ]))
    : (_ctx.name === 'default')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn retry-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDownload && _ctx.handleDownload(...args)))
          }, "点击重试")
        ]))
      : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.name), { key: 2 }))
}